export default __webpack_public_path__ + "static/media/commma.98d8eb52.svg";